import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=f30c012c&scoped=true&"
import script from "./SimpleForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SimpleForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SimpleForm.vue?vue&type=style&index=0&id=f30c012c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30c012c",
  null
  
)

export default component.exports